import { useQuery } from "@tanstack/react-query";
import { fetchCurrentUser, isAccountMissing } from "@/utils/api";
import { useAuthUser } from "@/utils/firebase";

/**
 * The logged in user, fetched once per session. Keyed by Firebase uid,
 * so another user logging in refreshes the user.
 */
export const useCurrentUser = () => {
  const authUser = useAuthUser();
  return useQuery({
    queryKey: ["current-user", authUser?.uid],
    queryFn: fetchCurrentUser,
    staleTime: Infinity,
    // Skip if the account is missing. Otherwise retry once.
    retry: (failureCount, error) =>
      !isAccountMissing(error) && failureCount < 1,
  });
};
